module.exports = __webpack_public_path__ + "img/user4.707a91f6.jpg";